import React, { useState, useEffect } from 'react'
import ImageMapper from 'react-image-mapper';
import 'react-web-tabs/dist/react-web-tabs.css';
import apiService from 'apiService';
import { showLoading, toast } from 'view/component/Alert';

const BodyParts = (props) => {
    const [Areas, setAreas] = useState([])
    const [Url, setUrl] = useState('')
    const [select, setselect] = useState('')
    const [img, setImg] = useState([])
    const [selectImgUrl, setselectImgUrl] = useState('')
    const [selectImg, setselectImg] = useState('')
    const [ref_WD, setRefWd] = useState([])

    const setPoly = (e) => {
        let x = e.nativeEvent.offsetX
        let y = e.nativeEvent.offsetY
        setAreas([...Areas].map(object => {
            if (object.id === select) {
                if (object.shape === "poly") {
                    return {
                        ...object,
                        coords: [...object.coords, x, y] //poly
                        // coords : [x,y, 20] //circle
                    }
                } else {
                    return {
                        ...object,
                        // coords: [...object.coords, x, y] //poly
                        coords: [x, y, 20] //circle
                    }
                }

            }
            else return object;
        }))
    }
    const onReload = () => {
        props.history.push("/pelayanan");
    };
    const handleChange = (e) => {
        let val = e.target.value
        let name = e.target.name
        setAreas([...Areas].map(object => {
            if (object.id === select) {
                return {
                    ...object,
                    [name]: val
                }
            }
            else return object;
        }))


    }
    const getBodyImage = async () => {
        let res = await apiService.get('/management/body-examination/read')
        if (res.code === 200) {
            setImg(res.data)
            setselectImg(res.data[0].id)
            setselectImgUrl(res.data[0].photo)
        }
    }
    const WoundDegree = async () => {
        let res = await apiService.get('/management/wound-degree/read?clinic_id=' + props.patient.clinic_id)
        if (res.code === 200) {
            setRefWd(res.data)
        }
    }

    const GetWoundDegree = async (body_id, url1) => {
        let res = await apiService.get('/registration/body-examination/read/visit/' + props.patient.id + '/' + body_id)
        if (res?.code === 200) {
            let shape = []
            res.data.map((a, k) => {
                shape.push({ id: a.id, name: a.name, shape: "poly", coords: a.coordinate?.split(","), preFillColor: "green", fillColor: a.wound_degree.color, wound_degree_id: a.wound_degree.id, body_id: a.body?.id, saved: true });
            })
            setAreas(shape);
        } else {
            setAreas([{ id: 1, name: '', shape: "poly", coords: [], preFillColor: "green", fillColor: 'yellow', wound_degree_id: 1, body_id: selectImg, saved: false }])
        }
        setselectImgUrl(url1);
    }
    const Post = async () => {
        showLoading('Gambar Disimpan')
        let array = [];
        Areas.map(a => {
            if (a.saved === false) {
                array.push({
                    visit_id: props.patient.id,
                    wound_degree_id: a.wound_degree_id,
                    name: a.name,
                    coordinate: a.coords,
                    body_id: selectImg
                })
            }
        })

        for (let index = 0; index < array.length; index++) {
            const element = array[index];
            let res = await apiService.post('/registration/body-examination/create', element)
        }
        toast({ status: 'success', text: 'berhasil disimpan' })
    }

    useEffect(() => {
        getBodyImage()
        WoundDegree()
    }, [img.length])
    useEffect(() => {
        if (selectImg !== '') {
            let url = img.find(a => a.id === selectImg).photo;
            GetWoundDegree(selectImg, url);
        }
    }, [selectImg])
    useEffect(() => {
        console.log(Areas)
    }, [Areas])
    return (
        <div>
            <div className="card col-12">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-3">
                            {/* List group */}
                            <ul className="list-group list-group-flush" data-toggle="checklist">
                                {img.map((a, k) => (
                                    <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4" href='#' key={k} onClick={(e) => setselectImg(a.id)}>
                                        <div className={selectImg === a.id ? "checklist-item checklist-item-success" : "checklist-item"} >
                                            <div className="checklist-info">
                                                <h5 className="checklist-title mb-0">{a.name}</h5>
                                            </div>
                                            <div>
                                                <div className="custom-control custom-checkbox custom-checkbox-success">
                                                    <input className="custom-control-input" id={`chk-todo-task-${k}`} name='body' onChange={(e) => setselectImg(a.id)} type="radio" checked={selectImg === a.id ? true : false} />
                                                    <label className="custom-control-label" htmlFor={`chk-todo-task-${k}`} />
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                                {/* <li className="checklist-entry list-group-item flex-column align-items-start py-4 px-4">
                                        <div className="checklist-item">
                                            <div className="checklist-info">
                                                <h5 className="checklist-title mb-0">Tangan</h5>
                                            </div>
                                            <div>
                                                <div className="custom-control custom-checkbox custom-checkbox-success">
                                                    <input className="custom-control-input" id="chk-todo-task-2"  name ='body' type="radio" defaultChecked={false} />
                                                    <label className="custom-control-label" htmlFor="chk-todo-task-2" />
                                                </div>
                                            </div>
                                        </div>
                                    </li> */}
                            </ul>
                        </div>
                        <div className="col-md-9">
                            <ImageMapper
                                src={selectImgUrl}
                                map={{
                                    name: "my-map",
                                    areas: Areas
                                }}
                                width={600}
                                // imgWidth={600}
                                responsive={true}
                                lineWidth={4}
                                onImageClick={(e) => setPoly(e)}

                            />
                            <button className="btn btn-sm btn-primary" onClick={() => setAreas([...Areas, { id: Areas.length + 1, name: Areas.length + 1, shape: "poly", coords: [], preFillColor: "green", fillColor: "blue", body_id: selectImg }])}>add</button>
                            {Areas.map((a, d) => (
                                <div className="row mt-2" key={d}>
                                    <button className={select === d + 1 ? "btn btn-sm btn-success" : "btn btn-sm btn-secondary"} onClick={() => setselect(d + 1)}>pilih</button>
                                    <input
                                        className="form-control form-control-sm col-md-5"
                                        type="text"
                                        placeholder="name"
                                        id="name"
                                        name="name"
                                        onChange={(e) => handleChange(e)}
                                        value={a.name}
                                    />
                                    <select
                                        name='wound_degree_id'
                                        className="form-control form-control-sm col-md-4"
                                        onChange={(e) => handleChange(e)}
                                        value={a?.wound_degree_id}
                                    >
                                        <option value={0}> Pilih skala .... </option>
                                        {ref_WD.map((d, k) => (
                                            <option key={k + 1} value={d.id}> {d.name} </option>

                                        ))}
                                    </select>
                                    <button className="btn btn-sm btn-danger" onClick={() => setAreas(Areas.filter(e => e.name !== a.name))}>x</button>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
                <div className="card-footer">
                    <div className="row">
                        <button className="btn btn-primary" onClick={() => Post()}>Simpan</button>
                        <button className="btn btn-danger" onClick={() => onReload}>
                            Tutup
                        </button>
                    </div>
                </div>
            </div>
        </div >
    )
}
export default BodyParts
